// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "app" + "." + "45f27ef1d7e40cd81d2b" + ".bundle.css";
};